import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import PageControl from 'designer/component/control/page/SelectControl'
import FavoriteControl from 'designer/component/control/favorite/SelectControl'

export const PageSelectSystem = (props) => (
  <DragElementWrapper {...props}>
    <PageControl {...props} />
  </DragElementWrapper>
)

export const PageSelectDisplay = (props) => (
  <ElementWrapper {...props}>
    <PageControl {...props} />
  </ElementWrapper>
)

export const FavoriteSelect = (props) => (
  <ElementWrapper {...props}>
    <FavoriteControl {...props} />
  </ElementWrapper>
)

export const selectTester = rankWith(1000, scopeEndsWith('select'))
